import { Role } from '@app/utils/protected-routes.utils';

export const textTransformRole = (role: unknown): string => {
  const validRoles = Object.values(Role);
  if (typeof role !== 'string' || !validRoles.includes(role as Role)) {
    return 'Unknown';
  }
  return role
    .toLowerCase()
    .replaceAll('_', ' ')
    .replaceAll(/\b\w/g, (char) => char.toUpperCase());
};

// Used to format keys from backend response for display
export const formatStringForDisplay = (input: string) => {
  // Replace underscores with spaces
  const spacedString = input.replaceAll('_', ' ');

  // Convert camelCase to spaces and normalize
  const normalizedString = spacedString.replaceAll(/([a-z])([A-Z])/g, '$1 $2');

  return normalizedString
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
